import { gql } from '@apollo/client';

import { FullBidFields } from 'query/SellerDealsWithCarves';

import BidStipulationFragments from './BidStipulations.fragments';
import CarveTableFragments from './CarveTable.fragments';

const BiddingAndPricingControllerFragments = {
  TimelineCard: gql`
    fragment BiddingAndPricingControllerCard on TimelineCard {
      ... on PlaceBidCard {
        bids {
          ...FullBidFields
        }
        assetClass: asset_class
        ...CarveTablePlaceBidCard
        ...BidStipulationsPlaceBidCard
      }
    }
    ${CarveTableFragments.PlaceBidCard}
    ${BidStipulationFragments.PlaceBidCard}
    ${FullBidFields}
  `,
};

export default BiddingAndPricingControllerFragments;
